import angular from 'angular';
import '../../app.constants';
import '../../services/errors';
import '../../services/notifications';
import '../../services/totem';
import '../../services/totem-tv';

const module = angular.module('whyline.controllers.totem-new-tv-welcome-and-thanks', [
  'whyline.constants',
  'whyline.services.totem-tv',
  'whyline.services.totem',
  'whyline.services.errors',
  'whyline.services.notifications',
]);

const TotemNewTvWelcomeAndThanksController = (SAFE_STATES, $scope, $state, $timeout, TotemService, TotemTvService, NotificationService, ErrorService) => {
  /*@ngInject*/

  // Init
  $scope.isWhylineEnterprise = true;
  $scope.totemEnabled = true;

  TotemTvService.SetButtonStatus('both', false);
  TotemTvService.SetButtonStatus('status-text', false);
  TotemTvService.SetButtonStatus('browserBack', false);

  TotemService.GetOneAsPromise($state.params.totemId)
    .then(res => {
      $timeout(() => {
        $scope.totemEnabled = true;
        NotificationService.Clear();
      });
    })
    .catch(ErrorService.handler);

  if ($state.current.name === SAFE_STATES.totemNewTvWelcome) {
    TotemTvService.SetPostMessage(null);
  }

  if ($state.current.name === SAFE_STATES.totemNewTvThanks) {
    $scope.postCheckInMessage = TotemTvService.PostMessage;
    $timeout(() => {
      $state.go(SAFE_STATES.totemNewTvWelcome);
    }, 9000);
  }
};

module.exports = module.controller('TotemNewTvWelcomeAndThanksController', TotemNewTvWelcomeAndThanksController);
